import { TableType } from '@repo/database/src/types';

export class CreateTableDto {
  type: TableType;
  name: string;
  game: string;
  timeoutInSeconds: number;
  isPublic: boolean;
  maxPlayers: number;
  ante?: number | null;
  bringIn?: number | null;
  smallBlind?: number | null;
  bigBlind?: number | null;
  smallBet?: number | null;
  bigBet?: number | null;
  rakeStructureId?: string;
  tournamentId?: string;
  tableNumber?: number;
}

export class CreateTableBody {
  params: CreateTableDto;
}
